<template>
  <div class="ac2" style="width: 100%">
    <!-- banner -->
    <div class="banner" style="width: 100%">
      <img src="/imgs/info1.jpg" style="width: 100%" />
    </div>
    <!-- 顶宽布局 -->
    <div class="container">
      <!-- 标题 -->
      <div class="a2-title">
        <h3>关于我们</h3>
        <div class="blink"></div>
      </div>
      <!-- 容器 -->
      <div class="a2-con">
        <div class="a2-r"></div>
        <div class="a2-l">
          <div class="a2-box">
            <p>
              北京学灯教育科技有限公司成立于2021年12月24日，注册地位于北京市通州区榆西一街1号院4号楼6层602室63642，经营范围包括一般项目：技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；计算机系统服务；软件开发；专业设计服务；数据处理服务；图文设计制作；社会经济咨询服务；组织文化艺术交流活动；文艺创作；企业管理咨询；教育咨询服务（不含涉许可审批的教育培训活动）；
            </p>
            <p>
              咨询策划服务；广告制作；广告发布；广告设计、代理；翻译服务；自费出国留学中介服务；因私出入境中介服务；日用百货销售；服装服饰零售；
            </p>
            <p>
              珠宝首饰零售；鞋帽零售；化妆品零售。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：网络文化经营；互联网信息服务；出版物零售。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）（不得从事国家和本市产业政策禁止和限制类项目的经营活动。）
            </p>
          </div>
        </div>
      </div>
      <!-- 文本区 -->
      <div class="a2-info">
        <!-- 使命 -->
        <!-- <div class="a2-item">
          <h3>主营业务介绍:</h3>
          <p>
            （1）以智慧农业为载体的非单一学科的研究性学习基地/营地的运营、科技项目课程开发与运营，客户为3-16岁学生个体和幼儿园、小学及初中学校；
          </p>
          <p>
            （2）专注学生学业成绩的相关信息的数据工程、通过数据分析为客户提供决策支持；
          </p>
          <p>
            （3）面向有教育人口家庭的，聚焦于科学解决问题思想、工具和方法的课程内容开发。
          </p>
        </div> -->

        <!-- 价值观 -->
        <!-- <div class="a2-item">
          <h3>联系我们:</h3>
          <p>北京敏学科技有限公司</p>
          <p>座机：010-64127077</p>
          <p>邮箱：percentcare@163.com</p>
          <p>地址：北京市海淀区学清路9号汇智大厦B座4层2单元502A室</p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";

export default {
  name: "ac1",
  components: {},
  data() {
    return {};
  },
  mounted() {
    document.title = "北京学灯教育科技有限公司";
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac2 {
  .banner {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
    margin-top: 80px;
  }
  .container {
    // height: 1000px;
    margin: 60px auto;
    padding-top: 30px;
    box-sizing: border-box;
    // 标题
    .a2-title {
      text-align: center;
      h3 {
        font-size: 21px;
        color: $colorZ;
      }
      .blink {
        width: 250px;
        height: 1px;
        background-color: $colorZ;
        margin: 5px auto;
      }
    }

    // 容器
    .a2-con {
      width: 100%;
      height: 500px;
      //   background-color: pink;
      box-sizing: border-box;
      @include flex();
      margin-top: 30px;
      // 左侧
      .a2-l {
        width: 50%;
        height: 100%;
        // background-color: red;
        position: relative;
        .a2-box {
          width: 80%;
          height: 80%;
          background-color: #4b80b7;
          position: absolute;
          left: 0;
          top: 50px;
          color: #fff;
          padding: 20px;
          box-sizing: border-box;
          p {
            font-size: 14px;
            margin: 15px auto;
          }
        }
      }
      // 右侧
      .a2-r {
        width: 50%;
        height: 100%;
        // background-color: yellow;
        background: url("/imgs/info2.jpg") no-repeat center;
        background-size: cover;
      }
    }
    // 文本区
    .a2-info {
      margin-top: 30px;
      .a2-item {
        margin-bottom: 60px;
        h3 {
          font-size: 24px;
          margin-bottom: 10px;
        }
        p {
          font-size: 14px;
          margin: 20px auto;
        }
      }
    }
  }
}
</style>
